// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"StandardLayout-module--bodyWrapper--3dk19"};